
import uiRouter from "@uirouter/angularjs";
import angularStorage from "angular-storage";
import angularJwt from "angular-jwt";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";
import TbAuthServiceModule from "tbClient/services/auth";
import HandleAuthenticationHook from "tbClient/hooks/HandleAuthenticationHook";
import ConfigureRequireAuthHook from "tbClient/hooks/RequireAuthHook";
import ConfigureLoadApiBasicDataHook from "tbClient/hooks/LoadBasicApiDataHook";

// Transition Hook Configuration Functions



function TrackerbaseAppInitialize(
    $rootScope,
    $injector
)
{
    $injector.invoke(HandleAuthenticationHook);
    $injector.invoke(ConfigureRequireAuthHook);
    $injector.invoke(ConfigureLoadApiBasicDataHook);
}

TrackerbaseAppInitialize.$inject = [
    "$rootScope",
    "$injector"
];

TrackerbaseAppInitialize.dependencies = DependencyListBuilder([
    HandleAuthenticationHook.dependencies,
    ConfigureRequireAuthHook.dependencies,
    ConfigureLoadApiBasicDataHook.dependencies,
    [
        uiRouter,
        angularStorage,
        angularJwt,
        TbAuthServiceModule
    ]
]);

export default TrackerbaseAppInitialize;



//////////////////
// WEBPACK FOOTER
// ./src/TrackerbaseAppInitialize.js
// module id = zfcb
// module chunks = 1